/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useInvisibleCaptcha } from 'features/yaSmartCaptcha';
import { useIsMobile, useScreenWidth } from 'shared/hooks';
import { MobileStub } from 'widgets/mobileStub';
import { ScreenWidthStub } from 'widgets/screenWidthStub';

const CheckIsMobile: FC = () => {
  const MIN_WIDTH = 1200;
  const isMobile = useIsMobile();
  const screenWidth = useScreenWidth();
  const { removeCaptcha, addCaptcha, isCaptchaNeed } = useInvisibleCaptcha();

  useEffect(() => {
    if (screenWidth >= MIN_WIDTH && !isCaptchaNeed) {
      addCaptcha();
    } else if (isMobile && screenWidth < MIN_WIDTH) {
      removeCaptcha();
    }
  }, [screenWidth, isMobile]);

  if (screenWidth >= MIN_WIDTH) {
    return <Outlet />;
  } else if (isMobile && screenWidth < MIN_WIDTH) {
    return <MobileStub />;
  } else if (!isMobile && screenWidth < MIN_WIDTH) {
    return <ScreenWidthStub />;
  }
};

export { CheckIsMobile };
